export default "__VITE_ASSET__D5t_6TCG__"